export default __webpack_public_path__ + "static/media/GAIA_label.7ac81a22.svg";